import React from 'react';
import Icon from '../../../../components/envago/Icon/Icon';

type Props = {
    variant: 'success' | 'info';
    title: string;
    description?: React.ReactNode;
};

const VARIANT_CONFIG = {
    success: { bg: 'bg-green-50 border-green-200', icon: Icon.Path.mdiCheckCircleOutline, iconColor: 'text-green-500' },
    info: { bg: 'bg-blue-50 border-blue-200', icon: Icon.Path.mdiInformationOutline, iconColor: 'text-blue-500' },
};

export const ImportResultBanner: React.FC<Props> = ({ variant, title, description }) => {
    const config = VARIANT_CONFIG[variant];

    return (
        <div role="status" aria-label={title} className={`${config.bg} border rounded py-8 px-4 flex flex-col items-center`}>
            <Icon path={config.icon} className={`w-20 h-20 ${config.iconColor}`} />
            <h3 className={'text-xl font-semibold text-center text-gray-800 mt-3'}>{title}</h3>
            {description && <p className={'text-sm text-center text-gray-600 mt-2'}>{description}</p>}
        </div>
    );
};
